import { Button, Col, Form, Input, Row, Upload, notification } from "antd";
import React, { useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { UploadOutlined } from "@ant-design/icons";

const ClaimComment = ({ claimId, onSuccess }) => {
	const [form] = Form.useForm();
	const [loadingButton, setLoadingButton] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [evidenceAdded, setEvidenceAdded] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const updateClaim = async (values) => {
		const claim = {
			...values,
		};

		delete claim.evidence;

		try {
			const url = api + `/claim/update/${claimId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, claim);
			if (data.success) {
				if (evidenceAdded) {
					addEvidence(values, claimId);
				} else {
					openNotification("success", "Success", "Comment Added");

					setTimeout(() => {
						onSuccess();
						setLoadingButton(false);
					}, 2000);
				}
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add claim comment"
			);
			console.error(err.message);
			return null;
		}
	};

	const addEvidence = async (values, id) => {
		const formData = new FormData();

		if (evidenceAdded && values.evidence && values.evidence.length > 0) {
			values.evidence.forEach((file) => {
				formData.append("files", file.originFileObj);
			});
		}

		try {
			const url = api + `/claim/add/comment/files/${id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				openNotification("success", "Success", "Comment Added");

				setTimeout(() => {
					onSuccess();
					setLoadingButton(false);
				}, 2000);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add claim comment files"
			);
			console.error(err.message);
			return null;
		}
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const onChangeEvidence = ({ fileList }) => {
		if (fileList.length === 0) {
			setEvidenceAdded(false);
		} else {
			setEvidenceAdded(true);
		}
	};

	const onFinish = (values) => {
		setLoadingButton(true);
		updateClaim(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				style={{ marginTop: "20px" }}
			>
				<Row gutter={16}>
					<Col span={24} xs={12}>
						<Form.Item
							label="Comment"
							name="comment"
							rules={[
								{
									required: true,
									message: "Comment is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} xs={12}>
						<Form.Item
							label="Evidence (Max Count: 10)"
							name="evidence"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={10}
								multiple={true}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								onChange={onChangeEvidence}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={24} sm={12} md={6}>
						<Button
							type="primary"
							htmlType="submit"
							loading={loadingButton}
							size="large"
							style={{
								width: "100%",
							}}
						>
							Add comment
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			<CustomForm />
		</>
	);
};

export default ClaimComment;
